(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["happyMndy-how-to-use"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  new Swiper(".how-to-use-swiper", {
    slidesPerView: 1.2,
    spaceBetween: 14,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      768: { slidesPerView: 3, spaceBetween: 30 },
    },
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
// Desktop Swiper (always initialized)
const desktopSwiper = new Swiper('.my_reviews_video_Swiper', {
  slidesPerView: 3,
  spaceBetween: 12,
  speed: 1000,
  navigation: {
    nextEl: '.cs_button_wrap.des .cs_reviews_next_button',
    prevEl: '.cs_button_wrap.des .cs_reviews_prev_button',
  },
  breakpoints: {
    320: { slidesPerView: 1.2, spaceBetween: 14 },
    768: { slidesPerView: 2.5, spaceBetween: 15 },
    1024: { slidesPerView: 3, spaceBetween: 12 },
  }
});

// Mobile Swiper (only if screen width < 768px)
if (window.innerWidth < 768) {
  const mobileSwiper = new Swiper('.mobile-reviews', {
    slidesPerView: 1.2,
    spaceBetween: 14,
    loop: false,
    speed: 1000,
    navigation: {
      nextEl: '.cs_button_wrap.mob .cs_reviews_next_button_mob',
      prevEl: '.cs_button_wrap.mob .cs_reviews_prev_button_mob',
    },
    breakpoints: {
      320: { slidesPerView: 1.2, spaceBetween: 14 },
      768: { slidesPerView: 2 },
      1024: { slidesPerView: 3 },
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["news-blog"] && !Shopify.designMode) return;
  try {
    
const desktopSwiper = new Swiper('.latest-news-swiper', {
  slidesPerView: 3.4,
  spaceBetween: 20,
  speed:1000,
  navigation: {
    nextEl: '.cs_slide-btn .cstm-button-next',
    prevEl: '.cs_slide-btn .cstm-button-prev',
  },
  breakpoints: {
    320: { slidesPerView: 1.2, spaceBetween: 20 },
    768: { slidesPerView: 2 },
    1024: { slidesPerView: 3.4 },
  }
});

const mobileSwiper = new Swiper('.latest-news-swiper', {
  slidesPerView: 1.2,
  spaceBetween: 20,
  loop: true,
  speed:1000,
  navigation: {
    nextEl: '.cs_slide-btn-mobl .cstm-button-next',
    prevEl: '.cs_slide-btn-mobl .cstm-button-prev',
  },
  breakpoints: {
    320: { slidesPerView: 1.2, spaceBetween: 20 },
    768: { slidesPerView: 2 },
    1024: { slidesPerView: 3 },
  }
});

  } catch(e) { console.error(e); }
})();
})();
